export const HeadingH1 = ({ title, uppercase, capitalize, className }) => {
  return (
    <div
      className={`font-bold text-primary text-2xl ${className} ${
        uppercase && "uppercase"
      } ${capitalize && "capitalize"}`}
    >
      {title}
    </div>
  );
};

export const HeadingH2 = ({ title, uppercase, capitalize, className }) => {
  return (
    <div
      className={`font-bold text-primary text-xl ${className} ${
        uppercase && "uppercase"
      } ${capitalize && "capitalize"}`}
    >
      {title}
    </div>
  );
};

export const HeadingH3 = ({ title, uppercase, capitalize, className }) => {
  return (
    <div
      className={`font-bold text-primary text-lg ${className} ${
        uppercase && "uppercase"
      } ${capitalize && "capitalize"}`}
    >
      {title}
    </div>
  );
};

export const HeadingH4 = ({ title, uppercase, capitalize, className }) => {
  return (
    <div
      className={`font-bold text-primary text-base ${className} ${
        uppercase && "uppercase"
      } ${capitalize && "capitalize"}`}
    >
      {title}
    </div>
  );
};

export const HeadingH5 = ({ title, uppercase, capitalize, className }) => {
  return (
    <div
      className={`font-bold text-primary text-sm ${className} ${
        uppercase && "uppercase"
      } ${capitalize && "capitalize"}`}
    >
      {title}
    </div>
  );
};

export const HeadingH6 = ({ title, uppercase, capitalize, className }) => {
  return (
    <div
      className={`font-bold text-primary text-xs ${className} ${
        uppercase && "uppercase"
      } ${capitalize && "capitalize"}`}
    >
      {title}
    </div>
  );
};
